export const endpoints = {
  auth: {
    v1: {
      authLogin: 'v1/auth/login',
      authRefreshToken: 'v1/auth/refreshToken',
      authLogout: 'v1/auth/logout',
      authRegister: 'v1/auth/register',
      authValidateEmail: 'v1/auth/validateEmail',
      authValidateGoogleLoginToken: 'v1/auth/validateGoogleLoginToken',
      authContinueWithGoogle: 'v1/auth/continueWithGoogle',
      authForgotPasswordPasswordReset: 'v1/forgotPassword/passwordReset',
      authForgotPasswordNewPassword: 'v1/forgotPassword/newPassword',
      authUsers: 'v1/users',
      forgotPasswordPasswordReset: 'v1/forgotPassword/passwordReset',
      profile: 'v1/Profile',
      profileConfirmDelete: 'v1/Profile/confirm-delete',
      profileDelete: 'v1/Profile/delete',
      twoFactorLoginEmailCode: 'v1/TwoFactor/login/email-code',
      twoFactorLoginVerify: 'v1/TwoFactor/login/verify',
      twoFactorLoginCancel: 'v1/TwoFactor/login/cancel',
      twoFactorStepUpStart: 'v1/TwoFactor/step-up/start',
      twoFactorStepUpEmailCode: 'v1/TwoFactor/step-up/email-code',
      twoFactorStepUpVerify: 'v1/TwoFactor/step-up/verify',
      twoFactorStepUpCancel: 'v1/TwoFactor/step-up/cancel',
      twoFactorEnrollmentStart: 'v1/TwoFactor/enrollment/start',
      twoFactorEnrollmentConfirm: 'v1/TwoFactor/enrollment/confirm',
      twoFactorEnrollmentCancel: 'v1/TwoFactor/enrollment/cancel',
      twoFactorDisable: 'v1/TwoFactor/disable',
    }
  },
  v1: {
    fiProfile: 'v1/fi-profile',
    subscriptions: 'v1/subscriptions',
    savings: 'v1/savings',
    snapshots: 'v1/snapshots',
    assets: 'v1/assets',
    assetSnapshots: 'v1/asset-snapshots',
    dashboard: 'v1/dashboard',
    setupStatus: 'v1/setup-status',
    goals: 'v1/goals',
    reminders: 'v1/monthly-reminders',
    currencies: 'v1/currencies',
    gdpr: 'v1/gdpr',
  }
};
